module.exports = __webpack_public_path__ + "img/vendors.0b4ca645.png";